import React from 'react';
import { useNavigate } from 'react-router-dom';

const KpiCard = ({ kpi, value, trend = null, isLoading = false, onClick = null }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) onClick();
    else if (kpi?.drilldownPath) navigate(kpi.drilldownPath);
  };

  if (isLoading) {
    return (
      <div className="rounded-xl border border-slate-700/50 bg-slate-800/50 p-4">
        <div className="mb-2 h-4 w-24 animate-pulse rounded bg-slate-700" />
        <div className="h-8 w-16 animate-pulse rounded bg-slate-700" />
      </div>
    );
  }

  const hasClick = onClick || kpi?.drilldownPath;
  const trendColor =
    trend === null
      ? 'text-slate-500'
      : trend > 0
        ? 'text-emerald-400'
        : trend < 0
          ? 'text-red-400'
          : 'text-slate-500';

  return (
    <div
      onClick={handleClick}
      className={`rounded-xl border border-slate-700/50 bg-slate-800/50 p-4 transition-all ${
        hasClick ? 'cursor-pointer hover:border-blue-500/50 hover:bg-slate-800' : ''
      }`}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-xs font-medium text-slate-400">{kpi?.label || 'KPI'}</p>
          <p className="mt-1 text-2xl font-semibold text-white">
            {value !== null && value !== undefined
              ? `${typeof value === 'number' ? value.toLocaleString() : value}${kpi?.suffix || ''}`
              : '—'}
          </p>
          {kpi?.description && <p className="mt-1 text-[10px] text-slate-500">{kpi.description}</p>}
        </div>
        {trend !== null && (
          <div className={`text-xs font-semibold ${trendColor}`}>
            {trend > 0 ? '↑' : trend < 0 ? '↓' : '→'} {Math.abs(trend)}%
          </div>
        )}
      </div>
    </div>
  );
};

export default KpiCard;
